{
    const readMore = document.querySelectorAll('.js-more-btn');

    const handleClick = (evt) => {
        const target = evt.target;
        const dataset = target.dataset;
        target.textContent =  target.textContent === dataset.more ? dataset.less : dataset.more;
        target.parentElement.classList.toggle('is-close');
    };

    readMore.forEach((button) => button.addEventListener('click', handleClick));
}
